import { useEffect, useState } from "react";
import { CiMail, CiUser } from "react-icons/ci";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import logo from "../../assets/logo-2.png";
import Input from "../ui/Input";
import { PhoneNumber } from "../ui/PhoneNumber";
import { useNavigate } from "react-router";
import { userType } from "../../helper/constant";
import { validEmail } from "../../helper/appConstant";
import { useSearchParams } from "react-router-dom";
import SelectField from "../ui/SelectField";
import MultiSelectCheckbox from "../ui/MultiSelectCheckbox";
import {
  checkEmailOrPhoneNumberExistOrNot,
  registrationUser,
  resetPassword,
  sentOtp,
} from "../../store/slice/auth";
import { useDispatch, useSelector } from "react-redux";
import OtpDialog from "../dialogs/OtpDialog";
import AuthRightSection from "./AuthRightSection";

export default function ResetPassword({
  searchParams,
  ...props
}) {
  const navigate = useNavigate("");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState({});
  const [focusedInput, setFocusedInput] = useState(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [userTypeData, setUserTypeData] = useState(userType);
  const { userExistingRoles } = useSelector((state) => state.auth);

  const images = [
    "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=1000&fit=crop",
    "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800&h=1000&fit=crop",
    "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=800&h=1000&fit=crop",
  ];

  useEffect(() => {

    const email = searchParams?.email;
    const phone = searchParams?.phone;
    const countryCode = searchParams?.countryCode;
    if (phone || email) {
      verifyPhoneEmail(email, phone, countryCode)
    }
  }, [searchParams]);

  useEffect(() => {
    if (userExistingRoles) {
      setUserTypeDisable();
    }
  }, [userExistingRoles]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const setUserTypeDisable = () => {
    let data = [...userTypeData];
    data.map((item, index) => {
      if (!userExistingRoles.includes(item?.id)) {
        data[index].disable = true;
      } else {
        data[index].disable = false;
      }
    });
    setUserTypeData(data);
  };

  const handleSignup = (e) => {
    e.preventDefault();
    if (!formData?.password) {
      setFormData(() => ({
        ...formData,
        passwordError: "Please enter password.",
      }));
      return;
    }
    if (formData?.password && formData?.password.length < 8) {
      setFormData(() => ({
        ...formData,
        passwordError: "Password must be minumum 8 characters.",
      }));
      return;
    }
    if (!formData?.confirmPassword) {
      setFormData(() => ({
        ...formData,
        confirmPasswordError: "Please enter confirm password.",
      }));
      return;
    }
    if (formData?.confirmPassword && formData?.confirmPassword.length < 8) {
      setFormData(() => ({
        ...formData,
        confirmPasswordError: "Password must be minumum 8 characters.",
      }));
      return;
    }
    if (formData?.confirmPassword != formData?.password) {
      setFormData(() => ({
        ...formData,
        confirmPasswordError: "Confirm password did not match with password",
      }));
      return;
    }
    if (!formData?.userType || formData?.userType?.length == 0) {
      setFormData(() => ({
        ...formData,
        userTypeError: "Please select user type.",
      }));
      return;
    }

    const data = {
      language: "en",
      email: formData?.email || "",
      userType: formData?.userType,
      phoneNumber: formData?.phoneNumber || "",
      newPassword: formData?.password,
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
    };
    dispatch(resetPassword(data, navigate));
  };

  const verifyPhoneEmail = (email, phone, countryCode) => {

    setFormData(() => ({
      ...formData,
      email: email,
      phoneNumber: phone,
      countryCode: countryCode
    }));
    const data = {
      email: email || "",
      phoneNumber: phone || "",
      countryCode: phone ? countryCode : "",
    }
    dispatch(checkEmailOrPhoneNumberExistOrNot(data));
  }

  return (
    <div className="container mx-auto p-4 shadow-lg rounded-md flex bg-gradient-to-br from-gray-50 to-blue-50" style={{ minHeight: '100vh' }}>
      {/* Left Section */}
      <AuthRightSection />
      {/* Right Section */}
      <div className="w-full p-5 md:w-1/2 flex flex-col justify-center bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2]"></div>

        <div className="mb-5 flex justify-center animate-fade-in">
          <img src={logo} alt="Logo" className="w-48" />
        </div>

        <h2 className="text-3xl font-medium text-gray-800 text-center bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text">
          Create New Password
        </h2>
        <p className="text-gray-500 font-normal text-sm mt-2 text-center mb-5">
          Your new password must be different from previous used password.
        </p>

        <div className="space-y-4">
          <div className="relative group">
            <div className="relative !focus-visible:outline-none">
              <Input
                type={showPassword?.password ? "text" : "password"}
                onFocus={() => setFocusedInput("password")}
                onBlur={() => setFocusedInput(null)}
                placeholder="Password"
                inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                onChange={(val) =>
                  setFormData(() => ({
                    ...formData,
                    password: val,
                    passwordError: "",
                  }))
                }
                error={formData?.passwordError}
              />
              <button
                type="button"
                onClick={() =>
                  setShowPassword(() => ({
                    ...showPassword,
                    password: !showPassword?.password,
                  }))
                }
                className={`absolute right-4 top-1/2 -translate-y-1/2 transition-all duration-300 ${focusedInput === "password"
                  ? "text-[#2BACE2]"
                  : "text-gray-400"
                  } hover:text-[#2BACE2]`}
              >
                {showPassword?.password ? (
                  <IoEyeOutline size={20} />
                ) : (
                  <IoEyeOffOutline size={20} />
                )}
              </button>
            </div>
          </div>

          <div className="relative group">
            <div className="relative !focus-visible:outline-none">
              <Input
                type={showPassword?.confirmPassword ? "text" : "password"}
                onFocus={() => setFocusedInput("password")}
                onBlur={() => setFocusedInput(null)}
                placeholder="Confirm Password"
                inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                onChange={(val) =>
                  setFormData(() => ({
                    ...formData,
                    confirmPassword: val,
                    confirmPasswordError: "",
                  }))
                }
                error={formData?.confirmPasswordError}
              />
              <button
                type="button"
                onClick={() =>
                  setShowPassword(() => ({
                    ...showPassword,
                    confirmPassword: !showPassword?.confirmPassword,
                  }))
                }
                className={`absolute right-4 top-1/2 -translate-y-1/2 transition-all duration-300 ${focusedInput === "password"
                  ? "text-[#2BACE2]"
                  : "text-gray-400"
                  } hover:text-[#2BACE2]`}
              >
                {showPassword?.confirmPassword ? (
                  <IoEyeOutline size={20} />
                ) : (
                  <IoEyeOffOutline size={20} />
                )}
              </button>
            </div>
          </div>

          <MultiSelectCheckbox
            id="categories"
            options={userTypeData}
            value={formData?.userType ? formData?.userType : ""}
            onChange={(val) =>
              setFormData(() => ({
                ...formData,
                userType: val,
                userTypeError: "",
              }))
            }
            placeholder="Select categories"
            focusedInput={focusedInput}
            setFocusedInput={setFocusedInput}
          />

          <div className="flex justify-center pt-2">
            <button
              onClick={handleSignup}
              className="md:w-2/3 w-full py-3 bg-gradient-to-r from-[#2BACE2] to-[#057BB5] text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 relative overflow-hidden group"
            >
              <span className="relative z-10">Reset</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#057BB5] to-[#2BACE2] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
